
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkinapp",
      function () {
        return require("private-next-pages/checkinapp.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkinapp"])
      });
    }
  